angular
  .module('tasks')
  .directive('taskAddComment', ["PATH", "localStorageService", "taskManagementService", function (PATH, localStorageService, taskManagementService) {
    return {
      restrict: 'E',
      scope: {
        cardId: '=',
        onAdd: '=',
        managers: '=',
        cardMembers: '='
      },
      templateUrl: PATH.components + 'taskManagement/addComment/view.html',
      link: function ($scope) {
        $scope.userInfo = localStorageService.get('userInfo').person;
        $scope.addComment = function () {
          // eslint-disable-next-line max-len
          var mentionedUsers = taskManagementService.getUsersMentioned($scope.comment, $scope.mentions);
          $scope.onAdd($scope.comment, false, mentionedUsers);
          $scope.comment = '';
        };
        $scope.mentions = getMentions();

        function getMentions() {
          return taskManagementService.getMentions($scope.managers, $scope.cardMembers);
        }

        $scope.$watch('cardMembers', function () {
          $scope.mentions = getMentions();
        });

      }
    };
  }]);



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/taskManagement/addComment/directive.js